module.exports = __webpack_public_path__ + "static/media/Mission_mobile1_SV.1a416fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mission_mobile1_SV.png
// module id = 1061
// module chunks = 0